export enum BondedWarehouseProjectValue {
    SELECTED = 1,
    UN_SELECTED = 0
}


// WEBPACK FOOTER //
// ./src/app/common/enums/bonded-warehouse-project.enum.ts